/**
 *
 * PeopleItem
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'redux';
import { withRouter, Link } from 'react-router-dom';
import UserIcon from '@material-ui/icons/AccountCircle';
import Mixpanel from 'utils/mixpanelService';
import Card from 'components/Card';
import ClassNames from 'classnames';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import Colors from 'utils/colors';
import Badge from 'components/Badge';
import LabelValue from 'components/LabelValue';
import RichTextReactRenderer from 'components/RichTextReactRenderer';
import Avatar from '@material-ui/core/Avatar';
import CardTooltip from 'components/ResourceItem/CardTooltip';
import { getImageFile } from 'utils/stringUtils';

const styles = theme => ({
  image: {
    marginBottom: 20,
    marginTop: 20,
    height: 77,
    width: 77,
    borderRadius: '50%',
  },
  placeholder: {
    color: Colors.gray,
  },

  link: {
    textDecoration: 'none',
    cursor: 'pointer',
    width: '100%',
  },
  mobileCardWrapper: {
    borderTop: '2px solid #D8D8D8',
    paddingTop: 20,
  },
  mobileImage: {
    marginTop: 0,
    height: 100,
    width: 100,
    marginBottom: 0,
  },
  imageWrapper: {
    height: 133,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  organization: {
    marginTop: 5,
    marginBottom: 10,
    '& span': theme.typography.pxSmall,
  },
  title: {
    lineHeight: '1.25',
    fontWeight: 450,
    marginBottom: 5,
  },
  titleWrapper: {
    display: '-webkit-box',
    margin: '0 auto',
    '-webkit-line-clamp': '2',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    height: 35 /* Fallback for non-webkit */,
  },
  subTitle: {
    ...theme.typography.pxSmall,
    color: theme.palette.primary.main,
  },
  description: {
    display: '-webkit-box',
    margin: '0 auto',
    '-webkit-line-clamp': '4',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '& p': {
      lineHeight: '1em !important',
    },
    '& span': {
      ...theme.typography.overline,
    },
  },
});

/* eslint-disable */

class PeopleItem extends React.PureComponent {
  redirect = () => {
    const {
      item: { name, title },
      location,
      recommendation,
    } = this.props;
    const pageName = location.pathname.split('/')[1];
    const finalPageName = pageName ? `${pageName}Page` : 'homePage';
    Mixpanel.track('Resource Card - Clicked', {
      name: name || title,
      type: 'person',
      page: finalPageName,
      recommendation,
    });
  };

  render() {
    const {
      classes,
      item,
      item: { title, slug, name, image = {}, organization, description, mastersDegree = '', doctoralDegree = '' },
      isSmall,
    } = this.props;
    let organizationsArray = [];
    if (
      !_isEmpty(_get(organization, 'items')) &&
      typeof organization === 'object'
    ) {
      organizationsArray.push(...organization.items);
    } else if (!_isEmpty(organization) && organization.length > 0) {
      organizationsArray = organization;
    }
    const file = !_isEmpty(_get(image, 'fields.file.url'))
    ? getImageFile(item)
    : image;
    return (
      <React.Fragment>
        {/* <Hidden xsDown> */}
        <Card
          background="#fff"
          borderColor="#E9ECED"
          height={isSmall ? 202 : 348}
        >
         <Link
              to={`/people/${slug}`}
              onClick={this.redirect}
              className={classes.link}
            >
          <Grid container justify="center">
              <CardTooltip item={item} tooltipId={slug}>
                <Grid item xs={12} className={classes.imageWrapper}>
                  {!_isEmpty(file)  ? (
                    <Avatar src={file} className={classes.image} alt='Person'/>
                  ) : (
                    <UserIcon
                      className={ClassNames(classes.image, classes.placeholder)}
                    />
                  )}
                  <Badge type="people" />
                </Grid>
              </CardTooltip>
            <Grid item xs={12}>
              <Typography
                variant="h6"
                align="center"
                color="textPrimary"
                className={classes.title}
              >
                {name || title} {mastersDegree || ''} {doctoralDegree || ''}
              </Typography>
            </Grid>

            {!isSmall && (
              <>
                {!!name && (
                  <Grid item xs={12} className={classes.titleWrapper}>
                    <Typography className={classes.subTitle} align="center">
                      {title}
                    </Typography>
                  </Grid>
                )}
                <Grid item xs={12} className={classes.organization}>
                  <LabelValue
                    value={organizationsArray}
                    type="organizations"
                    isCard
                  />
                </Grid>
                <Grid item xs={12} className={classes.description}>
                  <RichTextReactRenderer
                    data={description}
                    isDescription
                    type="name"
                  />
                </Grid>
              </>
            )}
          </Grid>
          </Link>
        </Card>
      </React.Fragment>
    );
  }
}

PeopleItem.propTypes = {
  classes: PropTypes.object,
  item: PropTypes.object,
  history: PropTypes.object,
  location: PropTypes.object,
  recommendation: PropTypes.bool,
  isSmall: PropTypes.bool,
};

PeopleItem.defaultProps = {
  recommendation: false,
};

export default compose(
  withRouter,
  withStyles(styles),
)(PeopleItem);
